/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { RenderConditionFromJSON, RenderConditionToJSON } from './RenderCondition';
import { ResourceAuthorizationRuleFromJSON, ResourceAuthorizationRuleToJSON } from './ResourceAuthorizationRule';

/**
 * A persisted instance of a block in the systems.
 * @export
 * @interface Block
 */

/**
 * Check if a given object implements the Block interface.
 */
export function instanceOfBlock(value) {
  if (!('blockRID' in value) || value['blockRID'] === undefined) return false;
  if (!('blockName' in value) || value['blockName'] === undefined) return false;
  if (!('blockParameters' in value) || value['blockParameters'] === undefined) return false;
  return true;
}
export function BlockFromJSON(json) {
  return BlockFromJSONTyped(json, false);
}
export function BlockFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'blockRID': json['blockRID'],
    'id': json['id'] == null ? undefined : json['id'],
    'pluginId': json['pluginId'] == null ? undefined : json['pluginId'],
    'blockName': json['blockName'],
    'blockParameters': json['blockParameters'],
    'parentZoneRID': json['parentZoneRID'] == null ? undefined : json['parentZoneRID'],
    'zoneRIDs': json['zoneRIDs'] == null ? undefined : json['zoneRIDs'],
    'condition': json['condition'] == null ? undefined : RenderConditionFromJSON(json['condition']),
    'foreach': json['foreach'] == null ? undefined : json['foreach'],
    'as': json['as'] == null ? undefined : json['as'],
    'authorize': json['authorize'] == null ? undefined : json['authorize'].map(ResourceAuthorizationRuleFromJSON)
  };
}
export function BlockToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'blockRID': value['blockRID'],
    'id': value['id'],
    'pluginId': value['pluginId'],
    'blockName': value['blockName'],
    'blockParameters': value['blockParameters'],
    'parentZoneRID': value['parentZoneRID'],
    'zoneRIDs': value['zoneRIDs'],
    'condition': RenderConditionToJSON(value['condition']),
    'foreach': value['foreach'],
    'as': value['as'],
    'authorize': value['authorize'] == null ? undefined : value['authorize'].map(ResourceAuthorizationRuleToJSON)
  };
}